import { atom } from "jotai";

import { NEED_HYDRATION } from "~/_constants";
import { TDao } from "~/_types/TDao";

const daoAtom = atom<TDao | null | typeof NEED_HYDRATION>(NEED_HYDRATION);

export { daoAtom };
